import React from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import Step01SVG  from "itd-common/assets/images/onboarding/tutorial_step_01.png";
import { ReactComponent as BadgeAppleSVG } from "itd-common/assets/images/onboarding/badge_applestore.svg";
import { ReactComponent as BadgeGoogleSVG } from "itd-common/assets/images/onboarding/badge_googleplay.svg";
import "./authAside.scss"

const T_PREFIX: string = 'pages.authAside.download2FA.';

const AuthDownload2FA: React.FC = () => {
  const { t } = useTranslation();

    return (
        <div className="platform-section" style={{ maxWidth: `23rem`  }}>
            <div className="row">
                <div className="col-md-12">
                    <h1 className="platform-title">
                        <span>{t(`${T_PREFIX}title1`)}</span>  {t(`${T_PREFIX}title2`)}
                    </h1>
                </div>
                <div className="row wrap_content">
                    <div className="col-md-6">
                        <div className="platform-step my-2">
                            <div className='d-inline-block'>
                                <span className="fs-7 fw-bold mb-1">{t(`${T_PREFIX}step1`)}</span>
                                <h3 className='fs-6 fw-bold'>{t(`${T_PREFIX}whatINeed`)}</h3>
                            </div>
                        </div>
                        <div className="platform-step mb-2">
                            <small className="fs-7">{t(`${T_PREFIX}description`)}</small>
                            <div className='d-inline-block'>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">    
                        <img src={Step01SVG} alt="Tutorial Step 01" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default (AuthDownload2FA);